
    import { computed, defineComponent, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router/composables'
    import { useI18n } from 'vue-i18n-composable'

    import PostPreviewList from '@/app/components/common/posts/PostPreviewList.vue'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useNewsStore } from '@/app/stores/news'

    import { useHeadful } from '@/common/composables/libs/headful'

    export default defineComponent({
        components: {
            PostPreviewList
        },
        props: {
            page: {
                type: Number,
                default: 1
            }
        },
        setup (props) {
            const headful = useHeadful()
            const i18n = useI18n()
            const router = useRouter()
            const newsStore = useNewsStore()

            const entries = computed(() => newsStore.entries.data)
            const paginationMeta = computed(() => newsStore.entries.meta)

            const paginate = async (page: number): Promise<void> => {
                await router.push({
                    name: 'news',
                    params: {
                        page: page.toString()
                    }
                })

                await newsStore.loadPage(page)
            }

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().reset()

                headful({
                    title: `${i18n.t('nav.news')} | ${i18n.t('meta.title')}`
                })

                await newsStore.loadPage(props.page)
            })

            return {
                entries,
                paginationMeta,
                paginate
            }
        }
    })
